export function validateUserName(username) {
  if (!username) {
    return "User Name is required";
  }
}

export function validateEmail(email) {
  if (!email) {
    return "Email is required";
  }

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (email.match(emailPattern)) {
    return "";
  } else {
    return "Invalid Email";
  }
}

export function validatePassword(password) {
  if (!password) {
    return "Password is required";
  }

  if (password.length < 8) {
    return "Password must be atleast 8 characters";
  }
}
